module.exports = __webpack_public_path__ + "img/slide-5.ff2e26c5.jpg";